import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const featuredArticles = articles.filter((a) => a.featured).slice(0, 6);

const articleImages: Record<string, string> = {
  'shougong-huangyou-ru-men-zhi-nan': 'https://readdy.ai/api/search-image?query=Artisan%20handmade%20butter%20food%20photography%20on%20rustic%20wooden%20surface%2C%20warm%20golden%20lighting%2C%20cream%20texture%2C%20minimal%20composition%2C%20editorial%20style%2C%20soft%20natural%20light%2C%20elegant%20gourmet%20aesthetic&width=800&height=520&seq=butter-guide-01&orientation=landscape',
  'fa-jiao-huang-you-shen-du-jie-xi': 'https://readdy.ai/api/search-image?query=Artisan%20cultured%20butter%20on%20ceramic%20plate%20with%20fresh%20herbs%2C%20warm%20kitchen%20lighting%2C%20rustic%20wooden%20table%2C%20cream%20and%20golden%20textures%2C%20elegant%20food%20photography%2C%20minimal%20composition&width=800&height=520&seq=fermented-butter-01&orientation=landscape',
  'huang-you-su-mian-bao-hong-bei': 'https://readdy.ai/api/search-image?query=Freshly%20baked%20golden%20croissants%20with%20butter%20on%20marble%20surface%2C%20warm%20morning%20light%2C%20flaky%20pastry%20texture%2C%20elegant%20bakery%20aesthetic%2C%20minimal%20composition%2C%20soft%20natural%20lighting&width=800&height=520&seq=butter-croissant-01&orientation=landscape',
  'xiao-pi-liang-huang-you-sheng-chan': 'https://readdy.ai/api/search-image?query=Small%20batch%20artisan%20butter%20production%20in%20clean%20modern%20workshop%2C%20copper%20tools%2C%20cream%20texture%2C%20warm%20ambient%20lighting%2C%20minimal%20aesthetic%2C%20professional%20food%20photography&width=800&height=520&seq=small-batch-01&orientation=landscape',
  'fa-jiao-huang-you-shi-yan-ri-ji': 'https://readdy.ai/api/search-image?query=Artisan%20butter%20fermentation%20experiment%20with%20glass%20jars%20and%20fresh%20cream%2C%20warm%20natural%20light%2C%20rustic%20wooden%20table%2C%20minimal%20composition%2C%20editorial%20food%20photography&width=800&height=520&seq=ferment-experiment-01&orientation=landscape',
  'hai-yan-jiao-tang-huang-you': 'https://readdy.ai/api/search-image?query=Artisan%20salted%20caramel%20butter%20on%20ceramic%20dish%20with%20sea%20salt%20crystals%2C%20warm%20ambient%20lighting%2C%20rustic%20wooden%20surface%2C%20minimal%20composition%2C%20elegant%20food%20photography&width=800&height=520&seq=salted-caramel-butter-01&orientation=landscape',
};

export default function FeaturedArticles() {
  return (
    <section className="py-16 md:py-22 bg-background-100">
      <div className="container-site">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-block text-sm font-medium text-accent-600 bg-accent-100/70 px-3 py-1 rounded-full mb-3">
              精选推荐
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              不容错过的精彩内容
            </h2>
          </div>
          <Link
            to="/category/shougong-huangyou-jiaocheng"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={articleImages[article.slug] || articleImages['shougong-huangyou-ru-men-zhi-nan']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={index > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-medium text-primary-600 bg-primary-100/70 px-2.5 py-1 rounded-full">
                    {categories.find((c) => c.slug === article.category)?.name || article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}